import { frontendURL } from 'dashboard/helper/URLHelper';
import ClinicFlowFrame from './ClinicFlowFrame.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/clinicflow/lembretes'),
    name: 'clinicflow_reminders',
    component: ClinicFlowFrame,
    props: { dashboardAppTitle: 'ClinicFlow — Enviar lembrete' },
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
  },
  {
    path: frontendURL('accounts/:accountId/clinicflow/conectar-whatsapp'),
    name: 'clinicflow_connect_whatsapp',
    component: ClinicFlowFrame,
    props: { dashboardAppTitle: 'ClinicFlow — Conectar WhatsApp' },
    meta: { permissions: ['administrator'] },
  },
];
